import '../../../../lib/assets/javascripts/devex/angular/services/routes.service';
import '../../../../lib/assets/javascripts/devex/angular/models/alert_handling_service';

var dependencies = [
  'models.alertHandlingService',
];

var recruiterNotesListComponentTemplate =
  '<div class="margin-bottom-large">' +
    '<textarea ng-model="vm.note" class="form-control margin-bottom-medium"></textarea>' +
    '<div class="row">' +
      '<div class="col-md-8 padding-top-medium">' +
        '<a ng-href="{{ ::vm.profile }}" target="_blank" class="text-blue small">' +
          'View notes on user profile' +
        '</a>' +
      '</div>' +
      '<div class="col-md-4 text-right">' +
        '<button class="btn btn-line-primary btn-sm padding-left-large padding-right-large"' +
          'ng-click="vm.add()">' +
          'Add note' +
        '</button>' +
      '</div>' +
    '</div>' +
    '<div ng-show="vm.notes.length" class="top-border margin-top-medium">' +
      '<div class="margin-top-large"' +
        'ng-repeat="note in vm.notes | orderBy:\'-created_at\'">' +
        '<div style="display: flex; flex-direction: column">' +
          '<div>' +
            '<strong class="small padding-right-small text-gray-li"' +
              'ng-bind="::note.creator.full_name">' +
            '</strong>' +
            '<em class="small padding-right-small text-gray-li">' +
              ' wrote on' +
            '</em>' +
            '<em class="small padding-right-medium text-gray-li"' +
              'ng-bind="::note.created_at | date:\'mediumDate\'">' +
            '</em>' +
          '</div>' +
          '<small ng-bind="::note.note" class="padding-right-small"></small>' +
          '<button class="btn-link small"' +
            'ng-click="vm.delete(note.id)"' +
            'ng-if="::vm.canDelete(note)">'+
            'Delete' +
          '</button>' +
        '</div>' +
      '</div>' +
    '</div>' +
  '</div>';

angular.module('components.recruiterNotesList', dependencies)
  .component('recruiterNotesList', {
    template: recruiterNotesListComponentTemplate,
    bindings: {
      consultant: '<',
      data: '=',
      callback: '&'
    },
    controller: [
      '$http',
      'alertHandlingService',
      'RoutesService',
      function RecruiterNotesListController($http, AlertHandling, Routes) {
        var that = this;

        that.notes = null;
        that.note = null;
        that.profile = null;

        /**
         * Gets all the tags for the typeahead
         *
         * @returns {undefined}
         */
        var init = function() {
          that.notes = that.data;

          var slugAndId = that.consultant.slug_and_id || that.consultant.slugAndId;
          that.profile = Routes.person_path(slugAndId, { show_notes: true });
        };

        /**
         * Adds a note to the given consultant, if succeeds, shows a
         * confirmation message, updates the notes list and cleans the textarea
         *
         * @returns {undefined}
         */
        that.add = function() {
          $http({
            'method': 'post',
            'url': '/api/public/current_user/notes',
            'data': {
              note: {
                notable_type: 'Consultant',
                notable_id: that.consultant.id,
                note: that.note
              }
            }
          }).then(function(response) {

            AlertHandling.showSuccessMessage('Note created successfully');

            that.notes.push(response.data);
            that.note = null;
          }).catch(function() {
            AlertHandling.showGenericErrorMessage();
          });
        };

        /**
         * Deletes the given note, if succeeds, shows a confirmation message
         * and updates the notes list
         *
         * @param {number} id - ID of the note to be deleted
         *
         * @returns {undefined}
         */
        that.delete = function(id) {
          $http({
            'method': 'delete',
            'url': '/api/public/current_user/notes/' + id
          }).then(function() {

            AlertHandling.showSuccessMessage('Note deleted successfully');

            that.notes = that.notes.filter(function(note) {
              return note.id !== id;
            });

            that.data = that.notes;
          }).catch(function() {
            AlertHandling.showGenericErrorMessage();
          });
        };

        /**
         * Checks if the current user owns the given note and therefore is allowed to delete it
         *
         * @param {object} note - The current note for which to check permissions
         *
         * @returns {boolean}
         */
        that.canDelete = function(note) {
          if (!note || !note.creator) {
            return false;
          }

          return note.creator.id === devex.data.user.id;
        };

        /**
         * DATA OBTAINING
         */
        that.$onInit = init;
      }
    ],
    controllerAs: 'vm'
  });
